var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "o-grid" }, [
    _c(
      "div",
      {
        staticClass: "o-grid__column",
        attrs: { "data-size": "sm:12 md:8 lg:8" }
      },
      _vm._l(_vm.categories, function(category) {
        return _c(
          "div",
          {
            key: category,
            staticClass:
              "c-process-list c-buffer-box c-buffer-box--border-all t-background-white t-margin-top-s t-margin-bottom-s"
          },
          [
            _c("h2", { staticClass: "t-text-style-beta t-margin-bottom-s" }, [
              _vm._v(_vm._s(category))
            ]),
            _vm._v(" "),
            _vm._l(_vm.getProcessesForCategory(category), function(process) {
              return [
                _c(
                  "process-teaser",
                  _vm._b({}, "process-teaser", process, false)
                )
              ]
            }),
            _vm._v(" "),
            _vm.$can("create", "Process") ||
            _vm.$can("create", "ProcessTemplate")
              ? [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "c-button c-button--primary t-margin-top-s t-margin-bottom-xs",
                      attrs: { to: "/create-process/" + category }
                    },
                    [_vm._v("Lägg till process")]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }